import _ from 'lodash';
import React, { Component } from 'react';

import { getImageStyle } from 'shared/utils/getImageStyle';
import classnames from 'classnames';
import styles from './styles.module.scss';

class ImageSlider extends Component {
  state = {
    chosenPicture: 0
  };

  previousImage = () => {
    if (!_.isNull(this.state.chosenPicture)) {
      this.setState(prevState => {
        if (prevState.chosenPicture > 0) {
          return { chosenPicture: prevState.chosenPicture - 1 };
        }
        return { chosenPicture: 0 };
      });
    }
  };

  nextImage = () => {
    if (!_.isNull(this.state.chosenPicture)) {
      this.setState(prevState => {
        if (prevState.chosenPicture >= this.props.images.length - 1) {
          return { chosenPicture: prevState.chosenPicture };
        }
        return { chosenPicture: prevState.chosenPicture + 1 };
      });
    }
  };

  render() {
    const { className, images = [] } = this.props;
    const { chosenPicture } = this.state;

    let imageStyle = getImageStyle({
      image: _.get(images[chosenPicture], 'image'),
      thumbnails: _.get(images[chosenPicture], 'thumbnails'),
      width: 770,
      height: 400,
      additionalStyles: {
        backgroundSize: 'contain'
      }
    });

    const renderPreview = _.map(images, (image, index) => {
      if (index === this.state.chosenPicture) {
        return (
          <div
            key={index}
            className={classnames(styles.chosenImage, styles.imagePreview)}
          />
        );
      }
      return (
        <div
          key={index}
          className={classnames(styles.notSelected, styles.imagePreview)}
        />
      );
    });

    return (
      <div className={classnames(styles.imageSliderWrapper, className)}>
        <div className={styles.image} style={imageStyle} />
        {images.length > 1 && (
          <div className={styles.sliderNavigation}>
            <div
              className={styles.navigationButton}
              onClick={this.previousImage}>
              <i
                className={classnames(
                  styles.materialIcons,
                  styles.navigateBefore,
                  'material-icons'
                )}>
                navigate_before
              </i>
              <div>Previous</div>
            </div>
            <div className={styles.imagePreviewRow}>{renderPreview}</div>
            <div className={styles.navigationButton} onClick={this.nextImage}>
              <div>Next</div>
              <i
                className={classnames(
                  styles.materialIcons,
                  styles.navigateNext,
                  'material-icons'
                )}>
                navigate_next
              </i>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default ImageSlider;
